import { type RouteRecordRaw } from "vue-router";

import { APP_AGENT_ROUTES as AGENT } from "@/Generated/Routes/paths";
import { buildBeforeEnterChain, initWSGuard } from "@/Router/guards";

export default [
  {
    path: AGENT.root.path,
    component: () => import("@/Components/layout/MainLayout.vue"),
    beforeEnter: buildBeforeEnterChain(initWSGuard),
    children: [
      {
        path: AGENT.root.path,
        components: {
          main: () => import("@/Views/agent/index.vue"),
          sidebar: () => import("@/Components/layout/SidebarLayout.vue"),
        },
        meta: {
          sidebar: true,
          drawer: false,
        },
        children: [
          {
            ...AGENT.root,
            component: () => import("@/Views/agent/Contacts.vue"),
            meta: {
              noHeader: true,
            },
          },
        ],
      },
    ],
  },
] as RouteRecordRaw[];
